// These class names are read by the GTM container's trigger configuration —
// they are not (only) styling hooks. Renaming or removing a value here is a
// silent breaking change (no test, lint, or runtime failure); coordinate
// with the GTM container config before changing any value.
const GTM_CLASSNAMES = {
	YOUTUBE_VIDEO_WRAPPER: 'youtube-video__wrapper',
	CITY_LINK: 'near-by-cities__link',
	FEATURED_CONTENT_CARD_LINK: 'featured-content-card__link',
	PSP_LINKS_CARD_LINK: 'psp-links-card__link',
	REVIEW_CARD_LINK: 'review-card__link',
	REVIEWS_FOOTER_LINK: 'reviews-footer__link',
	STICKY_JUMP_NAV_LINK: 'sticky-jump-nav-link',
	STICKY_RESERVE_BUTTON: 'sticky-reserve-button',
};

// Element ids read by the GTM container's trigger configuration ("Click ID"
// triggers) - same coordinate-before-renaming rule as GTM_CLASSNAMES above.
// STICKY_JUMP_NAV_LINK_ID_PREFIX is combined with a section id (see
// STICKY_NAV_SECTIONS in FacilityPageV2) to form each tab's id, e.g.
// "sticky-jump-nav-link-overview".
export const GTM_IDS = {
	STICKY_JUMP_NAV_LINK_ID_PREFIX: 'sticky-jump-nav-link-',
	STICKY_RESERVE_BUTTON: 'sticky-reserve-button',
};

export default GTM_CLASSNAMES;
